import actions from './actions';

const initState = {
	dataRetellLecture: [],
	retellLectureDetail: null,
	totalItems: 0,
	loading: false,
};

export default function repeatSentenceReducer(state = initState, action) {
	switch (action.type) {
		case actions.GET_RETELL_LECTURE:
			return { ...state, totalItems: 0, loading: true };
		case actions.GET_RETELL_LECTURE_SUCCESS:
			let { data, totalItems } = action.payload;
			let res = data ? data : [];
			return { ...state, dataRetellLecture: res, totalItems, loading: false };

		case actions.GET_RETELL_LECTURE_DETAIL:
			return { ...state, loading: true, totalItems: 0 };
		case actions.GET_RETELL_LECTURE_DETAIL_SUCCESS: {
			let { data } = action.payload;
			let res = data ? data : {};
			return { ...state, retellLectureDetail: res, loading: false };
		}

		case actions.SPEAKING_LOADING_FALSE: {
			return { ...state, loading: false };
		}

		default:
			return state;
	}
}
